<template>

    <el-button type="info" plain @click="goBackToList">
        <el-icon><Fold /></el-icon>
        返回列表
    </el-button>


    <el-tabs tab-position="left" style="height: 120%;" class="demo-tabs">

        <el-button icon="Search" style="float: right; margin: 5px;" @click="searchCourse()" circle />

        <input
        class="input-field"
        type="search"
        placeholder="课程名"
        id="courseName"
        style="float: right;"
        />
        <br>

      <el-tab-pane label="必学课程" style=" padding: 20px;">
        <el-row :gutter="20" v-if="hasSelected">
          <el-col :span="6" v-for="course in hasSelected" :key="course.courseId" @click="deleteProfessional(course.courseId)">
              <el-card style="max-width: 480px;" class="courseCard no-padding"> 
                <img :src="course.courseImg" style="width: 100%; height: 150px;"/>
                  <template #footer>
                    <h6>{{ course.courseName }}</h6>
                    <span class="courseCardFont">主讲人:{{ course.teacher.nickName }}</span>
                    <hr style="margin: 0px">
                    <span class="overlay-text-public" v-if="course.isPublic == 0">公开课</span>  
                    <span class="overlay-text-private" v-if="course.isPublic == 1">私有课</span>  
                    <span class="courseCardFont" style="float:right;">{{ course.headCount }}人参加</span>
                  </template> 
              </el-card>
          </el-col>
      </el-row>
      </el-tab-pane>
      <el-tab-pane label="全部课程" style=" padding: 20px;">
          <el-row :gutter="20" v-if="allCourse">
              <el-col :span="6" v-for="course in allCourse" :key="course.courseId" @click="course.states == 0 ? '' : addProfessional(course.courseId)">
                  <el-card style="max-width: 480px;" :class="course.states == 0 ? 'hasSelect' : 'courseCard'"> 
                      <img :src="course.courseImg" style="width: 100%; height: 150px;"/>
                      
                      <template #footer>
                        <h6>{{ course.courseName }}</h6>
                        <span class="courseCardFont">主讲人:{{ course.teacher.nickName }}</span>
                        <hr style="margin: 0px">
                        <span class="overlay-text-public" v-if="course.isPublic == 0">公开课</span>  
                        <span class="overlay-text-private" v-if="course.isPublic == 1">私有课</span>  
                        <span class="courseCardFont" style="float:right;">{{ course.headCount }}人参加</span>
                      </template> 
                  </el-card>
              </el-col>
          </el-row>
      </el-tab-pane>

  
    <nav aria-label="..." style="margin-left: 40%;">
      <ul class="pagination" style="float: center">
        <li class="page-item" @click="click_page(-2)">
          <a class="page-link" href="#">前一页</a>
        </li>
        <li
          :class="'page-item ' + page.is_active"
          v-for="page in pages"
          :key="page.number"
          @click="click_page(page.number)"
        >
          <a class="page-link" href="#">{{ page.number }}</a>
        </li>
        <li class="page-item" @click="click_page(-1)">
          <a class="page-link" href="#">后一页</a>
        </li>
      </ul>
    </nav>
</el-tabs>
  </template>
  
  <script setup>
  import { ref, onMounted } from "vue";
  import $ from "jquery";
  import { ElMessage, ElMessageBox } from "element-plus";
  import { useRoute } from "vue-router";
  import router from "@/router/index";
  
  const allCourse = ref([]);
  const hasSelected = ref([]);
  let current_page = 1;
  let current_courseName = '';
  const current_professionalId = ref('');
  let total_course = 0;
  let pages = ref([]);
  const Route = useRoute(); //获取到值

  const token = localStorage.getItem("token");
  
  onMounted(() => {
      // 获取路由参数并设置为 current_page
    current_page = parseInt(Route.params.page) || 1;
    current_courseName = Route.params.courseName || '';
    current_professionalId.value = Route.params.professionalId || '';
  
    getAllCourse(current_page, current_courseName, current_professionalId.value);
  });
  
  
  const getAllCourse = (page, courseName, professionalId) => {
  current_page = page;
  current_courseName = courseName;
  current_professionalId.value = professionalId;
    $.ajax({
      url: "http://124.222.105.205:5000/api/statistics/selectCourseCertifica",
      data: {
        page: page,
        courseName: courseName,
        professionalId: professionalId
      },
      headers: {
        Authorization: "Bearer " + token,
      },
      type: "post",
      success(resp) {
        if (resp.code == "200") {
            allCourse.value = resp.data.allCourse.list;
            hasSelected.value = resp.data.hasSelected;
            total_course = resp.data.allCourse.total;
            udpate_pages();
        }
        
      },
      error() {},
    });
  };
  
  const click_page = (page) => {
    if (page === -2) page = current_page - 1;
    else if (page === -1) page = current_page + 1;
    let max_pages = parseInt(Math.ceil(total_course / 8));
    if (page >= 1 && page <= max_pages) {
        let courseName = $("#courseName").val();
        getAllCourse(page, courseName, current_professionalId.value);
    }
  };
  
  const udpate_pages = () => {
    let max_pages = parseInt(Math.ceil(total_course / 8));
    let new_pages = [];
    for (let i = current_page - 2; i <= current_page + 2; i++) {
      if (i >= 1 && i <= max_pages) {
        new_pages.push({
          number: i,
          is_active: i === current_page ? "active" : "",
        });
      }
    }
    pages.value = new_pages;
    let courseName = $("#courseName").val();
    router.push({ name: "CourseCertifica", params: { page: current_page, professionalId: current_professionalId.value, courseName: courseName } });
  };
  
  
  const goBackToList = () => {
  router.push({ name: "ProfessionalCertifica", params: { page: 1, keyword:'' } });
}

const searchCourse = () => {
    let keyword = $("#keyword").val();
    getAllCourse(1, keyword, current_professionalId.value);
  }

  const addProfessional = (id) => {
    ElMessageBox.confirm("确认添加该课程为必学课程吗?", "添加课程", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
    })
    .then(() => {
        $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/addCourseProfessional",
        type: "post",
        data: {
          courseId: id,
          professionalId: current_professionalId.value,
        },
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg,
                });
                getAllCourse(current_page, current_courseName, current_professionalId.value);  
                
            } else {
                ElMessage({
                    type: "error",
                    message: resp.msg,
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "服务器异常!稍后再试!"
            });
        }
    });
        
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消",
      });
    });
}

const deleteProfessional = (id)  => {
    ElMessageBox.confirm("确认移除该必学课程吗?", "移除课程", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
    })
    .then(() => {
        $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/deleteCourseProfessional",
        type: "post",
        data: {
          courseId: id,
          professionalId: current_professionalId.value,
        },
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg,
                });
                getAllCourse(current_page, current_courseName, current_professionalId.value);  
                
            } else {
                ElMessage({
                    type: "error",
                    message: resp.msg,
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "服务器异常!稍后再试!"
            });
        }
    });
        
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消",
      });
    });
}

  </script>
  
  <style scoped>
  .courseCard {
    border-radius: 20px;
    margin: 20px 0px;
    padding: 0px;
    transition: transform 0.3s; /* 添加过渡效果 */
  }

  .hasSelect {
    border-radius: 20px;
    margin: 20px 0px;
    padding: 0px;
    transition: transform 0.3s; /* 添加过渡效果 */
    -webkit-filter: blur(2px); /* Chrome, Opera */
       -moz-filter: blur(2px);
        -ms-filter: blur(2px);    
            filter: blur(2px);
    
  }
  
  .courseCard:hover{
       cursor: pointer;
       transform: translateY(-10px); /* 在hover时向上移动5像素 */
      transition: 350ms;
      box-shadow: 12px 5px 5px rgb(164, 164, 164);
  }
  
  .courseCardFont{
    font-size: xx-small;
    color: gray;
  }
  
  .overlay-text-public {
      width: auto; /* Adjust width based on content */
      padding: 5px; /* Add padding for better appearance */
      background-color: rgba(255, 218, 163, 0.97); /* Set background color and opacity */
      font-size: 8px; /* Decrease font size */
      color: rgb(0, 0, 0); /* Set text color */
      border-radius: 5%; /* Add border radius for rounded corners */
  }
  
  .overlay-text-private {
      width: auto; /* Adjust width based on content */
      padding: 5px; /* Add padding for better appearance */
      background-color: rgba(230, 179, 245, 0.97); /* Set background color and opacity */
      font-size: 8px; /* Decrease font size */
      color: rgb(255, 255, 255); /* Set text color */
      border-radius: 5%; /* Add border radius for rounded corners */
  }
  
  /deep/ .el-card__body{
      padding: 0px;
    }

    .input-field {
 width: 300px; /* 输入框宽度 */
 padding: 5px;
 border: 1px solid #ccc; /* 边框样式 */
 border-radius: 5px; /* 边框圆角 */
 font-size: 16px; /* 字体大小 */
 outline: none; /* 去除默认轮廓 */
}
.input-field:hover,
.input-field:focus {
 border-color: #66afe9; /* 修改边框颜色 */
 box-shadow: 0 0 5px rgba(102, 175, 233, 0.6); /* 添加阴影效果 */
}

  
  </style>